// shared/cut-text.js — a person's text cut to a length, never through a
// character.
//
// `String.prototype.slice` counts UTF-16 units, so cutting "…😀.pdf" at 120
// can keep the first half of the emoji alone. A lone half is not text: it
// leaves JSON as "\ud83d", which PostgreSQL refuses in a jsonb column (an
// Activity line's details), so a file name with an emoji at the cut was a 500.
// This cuts at `max` units, and one fewer when the last would be a lone half,
// so the result is never longer than `max` by either count PostgreSQL or a
// browser uses.
//
// Pure: no imports, no DOM, no node builtins.
export function cutText(value, max) {
  const text = String(value ?? "");
  if (text.length <= max) return text;
  const cut = text.slice(0, max);
  return /[\uD800-\uDBFF]$/.test(cut) ? cut.slice(0, -1) : cut;
}
